import { useCallback, useEffect, useState } from 'react';
import { api } from '../services/api';

const REQUEST_TIMEOUT_MS = 15000;

export default function useGuestGuide(language) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ data: null, loading: true });
  const retry = useCallback(() => {
    setState({ data: null, loading: true });
    setAttempt(value => value + 1);
  }, []);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    const fail = () => {
      controller.abort();
      if (active) setState({ data: null, loading: false });
    };
    setState({ data: null, loading: true });
    const timeout = setTimeout(fail, REQUEST_TIMEOUT_MS);
    window.addEventListener('offline', fail);
    window.addEventListener('online', retry);
    window.addEventListener('focus', retry);

    if (navigator.onLine === false) fail();
    else api.request('/guest-guide', { cache: 'no-store', signal: controller.signal })
      .then(data => {
        const guide = data?.[language];
        if (!guide?.webGuide?.sections?.length || !Array.isArray(guide?.webHomeGuide?.sections) ||
            !guide.text || !Array.isArray(guide.languages) || !guide.commissionRate) {
          throw new Error('Invalid guest guide');
        }
        if (active && !controller.signal.aborted) setState({ data, loading: false });
      })
      .catch(() => { if (active) setState({ data: null, loading: false }); })
      .finally(() => clearTimeout(timeout));

    return () => {
      active = false;
      controller.abort();
      clearTimeout(timeout);
      window.removeEventListener('offline', fail);
      window.removeEventListener('online', retry);
      window.removeEventListener('focus', retry);
    };
  }, [attempt, language, retry]);

  return { document: state.data?.[language], loading: state.loading, retry };
}
